import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';

import { getAllResearchAction } from '../../Redux/Actions/ResearchAction';

import ProjectCard from '../ProjectCard/ProjectCard';

const RResearchProject = () => {

    const dispatch = useDispatch()
    const isLoading = useSelector((e) => e?.LoadingReducer?.isLoading)
    const researchList = useSelector((e) => e?.ResearchReducer?.researchList)

    useEffect(() => {
        getDetails()
    }, [])

    const getDetails = () => {
        dispatch(getAllResearchAction())
    }

    return (
        <section className="row">

            {
                isLoading ?
                    <div className='text-center'>
                        <Spinner animation="border" />
                    </div>
                    :
                    <>
                        {
                            researchList
                                .map((item, index) => (
                                    <div className="col-12 col-sm-6 col-md-4 mb-4" key={index}>
                                        <div className="card research-card h-100">
                                            <ProjectCard
                                                src={`https://api.coeupdspadelhi.in/uploads/${item?.image}`}
                                                params={item}
                                                path={`research/researchProject/${item?.title}`}
                                                title={item.title}
                                            />
                                        </div>
                                    </div>
                                ))
                        }
                    </>

            }
        </section>
    );
};

export default RResearchProject;